import React from 'react';
import { AlertTriangle, LoaderCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { useI18n } from '../../hooks/useI18n';

export const ConfirmDangerDialog = ({
  open,
  title,
  message,
  confirmLabel,
  loading = false,
  onClose,
  onConfirm
}) => {
  const { t } = useI18n();

  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      closeDisabled={loading}
      title={title}
      overlayClassName="z-[70]"
      panelClassName="max-w-md rounded-2xl p-4"
      contentClassName="mb-4"
    >
      <div className="space-y-5">
        <div className="flex gap-3 rounded-2xl border border-rose-200/80 bg-rose-50/70 p-4 dark:border-rose-500/20 dark:bg-rose-500/10">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-100 text-rose-600 dark:bg-rose-500/20 dark:text-rose-200">
            <AlertTriangle size={18} aria-hidden />
          </span>
          <p className="text-sm leading-6 text-neutral-600 dark:text-neutral-300">{message}</p>
        </div>
        <div className="flex justify-end gap-3">
          <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>
            {t('cancel')}
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? <LoaderCircle size={16} className="animate-spin" aria-hidden /> : null}
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
